import TarifaService from '@/service/TarifaService'

export default {
  namespaced: true,
  state: {
    tarifas: [],
    selected: {},
    tarifasOptions: [],
  },
  getters: {
    tarifas(state) {
      return state.tarifas
    },
    selected(state) {
      return state.selected
    },
    tarifasOptions(state) {
      return state.tarifasOptions
    },
  },
  mutations: {
    UPDATE_TARIFAS(state, tarifas) {
      state.tarifas = tarifas
    },
    UPDATE_SELECTED(state, selected) {
      state.selected = selected
    },
    SAVE_TARIFA(state, tarifa) {
      state.tarifas.push(tarifa)
    },
    EDIT_TARIFA(state, tarifa) {
      const index = state.tarifas.findIndex(tar => tar.tarifaId === tarifa.tarifaId)
      Object.assign(state.tarifas[index], tarifa)
    },
    DELETE_TARIFA(state, tarifaId) {
      const index = state.tarifas.findIndex(tar => tar.tarifaId === tarifaId)
      state.tarifas.splice(index, 1)
    },
    UPDATE_TARIFAS_OPTIONS(state, tarifasOptions) {
      state.tarifasOptions = tarifasOptions
    },
  },
  actions: {
    async findAll({ commit }) {
      const tarifas = await TarifaService.findAll()
      commit('UPDATE_TARIFAS', tarifas)
    },
    async findById({ commit }, tarifaId) {
      const tarifa = await TarifaService.findById(tarifaId)
      commit('UPDATE_SELECTED', tarifa)
    },
    async save(_, multipart) {
      const data = await TarifaService.uploadMultipart(multipart)
      return data
    },
    async edit({ commit }, { tarifaId, tarifa }) {
      const edited = await TarifaService.edit(tarifaId, tarifa)
      commit('EDIT_TARIFA', edited)
    },
    async deleteById({ commit }, tarifaId) {
      await TarifaService.deleteById(tarifaId)
      commit('DELETE_TARIFA', tarifaId)
    },
    setOptions({ getters, commit }) {
      const options = getters.tarifas.map(tarifa => ({
        label: tarifa.nomeTarifa,
        tarifaId: tarifa.tarifaId,
        servicoId: tarifa.servicoId,
      }))
      commit('UPDATE_TARIFAS_OPTIONS', options)
    },
    setOptionsComNomeServico({ getters, commit }, servicos) {
      const tarifas = getters.tarifas.map(tarifa => ({
        ...tarifa,
        nomeServico: servicos.find(servico => servico.id === tarifa.servicoId).nomeServico,
      }))
      commit('UPDATE_TARIFAS', tarifas)
    },
  },
}